import * as types from './types';
import firebaseService from 'Services/firebaseService';

/**
 * Set Registration Form Config
 */
export function setRegistrationConfig(config) {
  return dispatch => {
    /*
        Set User Data
         */
    dispatch({
      type: types.SET_REGISTRATION_CONFIG,
      payload: config,
    });
  };
}

/**
 * Reset Registration config
 */
export function resetRegistrationConfig() {
  return {
    type: types.RESET_REGISTRATION_CONFIG,
  };
}

/**
 * Save the registration form draft on server
 */
export function updateRegistrationConfig(formData) {
  return async dispatch => {
    try {
      const newId = await firebaseService.updateRegistrationCode(formData);
      dispatch({
        type: types.UPDATE_REGISTRATION_CONFIG,
        payload: null,
      });
      return newId;
    } catch (error) {
      console.warn('Error updating registration code : ', error);
      throw new Error(error);
    }
  };
}
